export default __webpack_public_path__ + "static/media/main_slide_Image4.b0c050a8.jpg";